function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9106"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9659",
    d: "M27.5 0A27.5 27.5 0 1 1 0 27.5 27.5 27.5 0 0 1 27.5 0z",
    style: {
      opacity: 0.063,
      fill: "#492cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-whatsapp",
    d: "M17.23 5.195a10.045 10.045 0 0 0-15.8 12.118L0 22.515l5.324-1.4a10.012 10.012 0 0 0 4.8 1.221A10.139 10.139 0 0 0 20.265 12.3a10.082 10.082 0 0 0-3.035-7.1zm-7.1 15.452a8.332 8.332 0 0 1-4.252-1.163l-.3-.181-3.157.828.841-3.08-.2-.317A8.363 8.363 0 1 1 18.569 12.3a8.44 8.44 0 0 1-8.441 8.347zm4.576-6.247c-.249-.127-1.484-.733-1.714-.814s-.4-.127-.565.127-.647.814-.8.986-.294.19-.543.063a6.83 6.83 0 0 1-3.415-2.985c-.258-.443.258-.412.737-1.371a.465.465 0 0 0-.023-.439c-.06-.131-.562-1.367-.77-1.867s-.412-.421-.565-.43-.312-.009-.479-.009a.93.93 0 0 0-.669.312 2.82 2.82 0 0 0-.878 2.094 4.916 4.916 0 0 0 1.022 2.6 11.213 11.213 0 0 0 4.288 3.791 4.91 4.91 0 0 0 3.013.629 2.57 2.57 0 0 0 1.692-1.194 2.1 2.1 0 0 0 .145-1.194c-.06-.118-.227-.181-.476-.299z",
    transform: "translate(17.367 15.117)",
    style: {
      fill: "#492cbd"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7e2b4cc3.svg";
export { ForwardRef as ReactComponent };